<template>
  <div id="page-settings-sync">

    <!-- BREADCRUMB SECTION -->
    <vs-row class="mb-5" vs-align="center">
      <vs-col vs-w="12">
        <h2 class="breadcrumb">Ρυθμίσεις εισαγωγής προϊόντων & συνδέσμων</h2>
        <p style="margin-bottom: 10px;">
          Παρακάτω θα βρείτε οδηγίες για να μπορέσετε να προσθέσετε προϊόντα και συνδέσμους μέσω αρχείου <strong>XML</strong> ή <strong>Excel</strong>.
        </p>
        <hr><br>
        <p>Παρακαλώ επιλέξτε τι είδους σύνδεση επιθυμείτε: <a href="#" @click.prevent="xmlImport = true; xlsImport = false;">σύνδεση XML</a> ή <a href="#" @click.prevent="xlsImport = true; xmlImport = false;">χειροκίνητη εισαγωγή μέσω XLS</a></p>
      </vs-col>
    </vs-row>

    <div class="vx-card p-6" v-if="xmlImport">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="flex items-end mb-3">
            <feather-icon icon="FileIcon" class="mr-2" svgClasses="w-5 h-5"/>
            <h4 class="leading-none font-medium text-primary">Διεύθυνση URL αρχείου XML</h4>
          </div>
          <p>Κάντε επικόλληση του url στα παρακάτω πεδίο.</p>
          <vs-divider/>
          <div class="vx-row mt-6">
            <div class="vx-col sm:w-1/4 w-full">
              <span>Url (.xml format)</span>
            </div>
            <div class="vx-col sm:w-3/4 w-full">
              <vs-input type="url" class="w-full" icon-pack="feather" icon="icon-link" icon-no-border v-model="item.url"/>
            </div>
          </div>
        </div>
      </div>

      <!-- start::row -->
      <div class="vx-row">
        <div class="vx-col w-2/3">
          <div class="mt-8 flex flex-wrap items-center">
            <vs-button v-if="item && item.url" class="mt-2 ml-2 vs-button-danger vs-button-border" @click="deleteAllProducts">
              Επαναφορά Εφαρμογής
            </vs-button>
            <vs-button v-if="item && item.url" @click="updateProducts" color="warning" type="filled" icon="update" class="ml-2 mt-2">
              Ανανέωση στοιχείων μέσω XML
            </vs-button>
          </div>
        </div>
        <div class="vx-col w-1/3">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button class="ml-auto mt-2" @click="openConfirm()">Αποθήκευση</vs-button>
          </div>
        </div>
      </div>
      <vs-divider/>

      <div class="vx-row">
        <div v-if="item && item.url" class="vx-col pt-2">
          <p>*: Αν επιθυμείτε άμεση/αυτόματη  ανανέωση των στοιχείων λόγω μεταβολών στο xml  πιέστε αποδοχή.</p>
        </div>
      </div>
      <vs-divider/>

      <div class="vx-row">
        <div class="vx-col pt-2">
          <p>Αν θέλετε να γίνει εισαγωγή των συνδέσμων για τα προϊόντα που δε έχουν πατήστε <a href="#" @click="findSkroutzUrls()">εδώ</a></p>
        </div>
      </div>
      <!-- end::row -->
    </div>
    <!-- start::confirmation popup -->
    <vs-popup class="holamundo" title="Επιλογή εργασίες εισαγωγής" :active="displayPopUp" @close="closePopUp">

      <!-- start::pop up content -->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <p>
            Επιλέξτε μια από τις παρακάτω επιλογές:
          </p>
          <p>
            Στην πρώτη επιλογή το σύνολο το προϊόντων σας αφού διαγραφούν θα
            ενημερωθούν και πάλι εκ νέου.
          </p>
          <p>
            Με τη δεύτερη επιλογή θα προστεθούν νέο προϊόντα στα ήδη υπάρχοντα.
          </p>
        </div>
      </div>
      <!-- start::pop up content -->

      <!-- start::pop up actions -->
      <div class="vx-row">
        <div class="vx-col w-1/2">
          <div class="mt-8 flex flex-wrap items-center">
            <vs-button class="mt-8 flex flex-wrap items-center" @click.prevent="deleteAndCreate">
              1. Διαγραφή και επαναεισαγωγή προϊόντων
            </vs-button>
          </div>
        </div>
        <div class="vx-col w-1/2">
          <div class="mt-8 flex flex-wrap items-center">
            <vs-button class="mt-8 flex flex-wrap items-center" @click.prevent="doNotDeleteUpdate">
              2. Ενημέρωση υπαρχόντων προϊόντων με νέα
            </vs-button>
          </div>
        </div>
      </div>
      <!-- end::pop up actions -->

    </vs-popup>


    <vs-popup class="holamundo" title="Επιβεβαίωση διαγραφής προϊόντων" :active="removeDisplayPopUp" @close="removeClosePopUp">

      <!-- start::pop up content -->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <p>
            Κάνοντας κλικ στην παρακάτω επιλογή 'Διαγραφή Προϊόντων', θα αφαιρεθούν άμεσα και οριστικά όλα τα προϊόντα που περιέχονται στο Excel αρχείο από την πλατφόρμα σας, μαζί με τους συνδέσμους που έχετε καταχωρίσει. Παρακαλούμε σημειώστε ότι αυτή η διαδικασία είναι αμετάκλητη. Είστε βέβαιοι ότι θέλετε να προχωρήσετε;
          </p>
        </div>
      </div>
      <!-- start::pop up content -->

      <!-- start::pop up actions -->
      <div class="vx-row">
        <div class="vx-col w-1/2">
          <div class="mt-8 flex flex-wrap items-center">
            <vs-button class="mt-8 flex flex-wrap items-center" @click.prevent="removeAllXLSProducts(item.file, 'remove')">
              Διαγραφή Προϊόντων
            </vs-button>
          </div>
        </div>
      </div>
      <!-- end::pop up actions -->

    </vs-popup>

    <!-- start::confirmation popup -->
    <validation-observer v-slot="{invalid}">
      <!-- start::form -->
      <form v-if="xlsImport">
        <!-- start::title -->
        <vs-row class="mb-5" vs-align="center">
          <vs-col vs-w="12">
            <h2 class="breadcrumb">Παράμετροι Excel</h2>
            <p>
              Για την καταχώρηση των προιόντων παρακαλώ όπως χρησιμοποιηθεί συγκεκριμένη μορφή αρχείου (παρακάτω link).
            </p>
            <a href="/DEMO_EISAGOGIS_PROIONTWN.xlsx" target="_blank">Πρότυπο αρχείο εισαγωγής</a>
          </vs-col>
        </vs-row>
        <!-- end::title -->

        <!-- start::file upload -->
        <div v-if="!item.file" class="vx-row mt-6 excel-import">
          <div class="vx-col w-full">
            <validation-provider rules="ext:xls,xlsx" v-slot="{errors}">
              <input type="file" ref="fileInput" class="hidden" accept=".xlsx, .xls" @change="handleClick">
              <div @click="$refs.fileInput.click()" @drop="handleDrop" @dragover="handleDragover"
                   @dragenter="handleDragover"
                   class="px-8 py-16 cursor-pointer text-center border-2 border-dashed d-theme-border-grey-light d-theme-dark-bg text-xl">
                <feather-icon icon="UploadCloudIcon" svgClasses="h-16 w-16 stroke-current text-grey" class="block" />
                <span>Αποθέστε το αρχείο ή κάντε </span>
                <span class="font-medium text-primary" @click.stop="$refs.fileInput.click()">Αναζήτηση</span>
                <!-- <vs-button type="border" @click.stop="$refs.fileInput.click()">Browse</vs-button> -->
              </div>
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>
        <!-- end::file upload -->
        <!-- start::we have file to upload -->
        <div v-else class="vx-row mt-6 excel-import">
          <div class="vx-col w-full">
            <div
                class="px-8 py-16 cursor-pointer text-center border-2 border-dashed d-theme-border-grey-light d-theme-dark-bg text-xl">
              <feather-icon icon="UploadCloudIcon" svgClasses="h-16 w-16 stroke-current text-grey" class="block" />
              <span>Θα γίνει ανέβασμα του αρχείου:
                <strong>{{ item.file.name }}</strong>
              </span>
              <span @click.prevent="cancelUpload" class="font-medium text-primary">
                ακύρωση
              </span>
            </div>
          </div>
        </div>
        <!-- end::we have file to upload -->

        <!-- start::action buttons -->
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <div class="mt-8">
              <vs-button class="mt-2 ml-2 vs-button-danger vs-button-border" @click="deleteAllProducts">
                Επαναφορά Εφαρμογής
              </vs-button>
              <vs-button :disabled="invalid" @click="removeXls" class="mt-2 ml-1" color="warning">Διαγραφή προϊόντων</vs-button>
            </div>
          </div>
          <div class="vx-col w-1/2">
            <div class="mt-8 flex flex-wrap items-center justify-end">
              <vs-button :disabled="invalid" @click="uploadXls" class="ml-auto mt-2">Εισαγωγή προϊόντων</vs-button>
            </div>
          </div>
        </div>
        <!-- end::action buttons -->
      </form>
      <!-- end::form -->
    </validation-observer>
    <vs-button style="display:none;" class="mt-2 vs-button-warning vs-button-border" @click="syncLinks()">
      Εισαγωγή συνδέσμων (πηγών)
    </vs-button>
  </div>
  <!-- end::component container -->
</template>
<script>
import vSelect from 'vue-select'
import XLSX from 'xlsx'
import axios from '@/axios.js'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { ext } from 'vee-validate/dist/rules'

extend('ext', {
  ...ext,
  message: 'Το αρχείο πρέπει να είναι .xls ή .xlsx',
})
export default {
  components: {
    vSelect,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      xmlImport: false,
      xlsImport: false,
      xfilename: '',
      apiEndpoint: localStorage.getItem('apiEndpoint'),
      token: localStorage.getItem('accessToken'),
      initiated: false,
      initiatedSync: false,
      item: {
        url: '',
        file: null
      },
      excelData: {
        header: null,
        results: null,
        meta: null
      },
      displayPopUp: false,
      removeDisplayPopUp: false,
    }
  },
  methods: {
    updateProducts() {
      this.$vs.dialog({
        color: 'primary',
        title: `Ενημέρωση των προϊόντων`,
        text: `Θα γίνει ενημέρωση προϊόντων και τιμών από το αρχείο xml. Για αποδοχή της διαδικασίας κάντε κλικ στο
        κουμπί αποδοχή για ακύρωση κάντε κλικ στο Χ. Η διάρκεια της διαδικασίας είναι από 1 έως 3 λεπτά και είναι
        ανάλογη προς το πλήθος των προϊόντων σας`,
        acceptText: 'αποδοχή',
        accept: this.acceptAlert,
      })
    },
    acceptAlert() {
      this.$vs.loading()
      this.$store.dispatch('xmlUpdate').then((response) => {
        if (response.error === false) {
          this.$vs.notify({
            color: 'success',
            title: 'Επιτυχία',
            position: 'top-right',
            text: 'Η ενημέρωση έγινε.',
          })

          this.$vs.loading.close()
        } else {
          this.$vs.notify({
            color: 'error',
            title: 'Αποτυχία',
            position: 'top-right',
            text: 'Η ενημέρωση δεν έγινε',
          })
          this.$vs.loading.close()
        }
      })
    },
    generateData({header, results, meta}) {
      this.excelData.header = header
      this.excelData.results = results
      this.excelData.meta = meta
      // if (this.onSuccess) this.onSuccess(this.excelData)
    },
    getHeaderRow(sheet) {
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C = undefined
      const R = range.s.r
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({c: C, r: R})]
        /* find the cell in the first row */
        let hdr = `UNKNOWN ${C}` // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    },
    handleDragover(e) {
      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
    },
    handleDrop(e) {
      e.stopPropagation()
      e.preventDefault()
      const files = e.dataTransfer.files
      if (files.length !== 1) {
        this.$vs.notify({
          title: 'Login Attempt',
          text: 'Only support uploading one file!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return
      }
      const rawFile = files[0] // only use files[0]
      if (!this.isExcel(rawFile)) {
        this.$vs.notify({
          title: 'Login Attempt',
          text: 'Only supports upload .xlsx, .xls, .csv suffix files',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.uploadFile(rawFile)
    },
    removeTrailingZeros(val) {
      val = val.replace('00', '0');
      val = val.replace('01', '1');
      val = val.replace('02', '2');
      val = val.replace('03', '3');
      val = val.replace('04', '4');
      val = val.replace('05', '5');
      val = val.replace('06', '6');
      val = val.replace('07', '7');
      val = val.replace('08', '8');
      val = val.replace('09', '9');
      return val;
    },
    readerData(rawFile) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = e => {
          const data = e.target.result
          const workbook = XLSX.read(data, {type: 'array'})
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          const header = this.getHeaderRow(worksheet)
          const results = XLSX.utils.sheet_to_json(worksheet)
          const meta = {sheetName: firstSheetName}
          this.generateData({header, results, meta})
          resolve()
        }
        reader.readAsArrayBuffer(rawFile)
      })
    },
    handleClick(e) {
      const files = e.target.files
      const rawFile = files[0]
      if (!rawFile) return
      // console.log(rawFile);
      this.uploadFile(rawFile)
    },
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    },
    uploadFile(file) {
      this.$refs['fileInput'].value = null // fix can't select the same excel
      this.item.file = file;
      this.xfilename = this.item.file.name;

      // console.log(this.item.file.name);

      // this.readerData(file)
    },
    openConfirm() {
      let vm = this;
      if (!vm.item.url && !vm.xfilename) {
        vm.saveSettings();
      } else {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Επιβεβαίωση`,
          acceptText: 'Αποδέχομαι',
          cancelText: 'Ακύρωση',
          text: 'Με την κίνηση αυτή θα σβηστούν όλα τα προϊόντα και θα ξαναπεραστούν από την πηγή που ορίσατε. Είστε σίγουρος;',
          accept: this.saveSettings
        })
      }
    },
    findSkroutzUrls() {
      let vm = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Επιβεβαίωση`,
        text: 'Με την κίνηση αυτή θα ξεκινήσει η διαδικασία εύρεσης συνδέσμων για όλα τα προϊόντα. Είστε σίγουρος;',
        acceptText: 'Εύρεση',
        cancelText: 'Ακύρωση',
        accept: this.findSkroutzUrlsAction
      })
    },
    deleteAllProducts() {
      let vm = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Επιβεβαίωση`,
        text: 'Με αυτή την ενέργεια, θα διαγραφούν όλα τα προϊόντα, οι σύνδεσμοι και τα αποτελέσματα της εφαρμογής. Η εφαρμογή θα επανέλθει στις αρχικές της ρυθμίσεις, σαν να είναι καινούρια. Είστε βέβαιος ότι θέλετε να συνεχίσετε;',
        acceptText: 'Επαναφορά',
        cancelText: 'Ακύρωση',
        accept: this.deleteAllProductAction
      })
    },
    findSkroutzUrlsAction() {
      // let vm = this;
      // vm.$vs.loading();
      // axios.defaults.baseURL = vm.apiEndpoint;
      // axios.defaults.headers.common = {'Authorization': `bearer ${vm.token}`}
      // axios.get('/products/create-skroutz-urls-from-names')
      //     .then((response) => {
      //       vm.$vs.notify({
      //         color: 'success',
      //         title: 'Επιτυχία',
      //         position: 'top-right',
      //         text: 'Οι σύνδεσμοι βρέθηκαν με επιτυχία.'
      //       });
      //       vm.$vs.loading.close();
      //     })
      //     .catch((error) => {
      //       vm.$vs.notify({
      //         color: 'danger',
      //         title: 'Αποτυχία',
      //         position: 'top-right',
      //         text: 'Παρουσιάστηκε κάποιο πρόβλημα.'
      //       });
      //       vm.$vs.loading.close();
      //     })
      let vm = this;
      axios.defaults.baseURL = vm.apiEndpoint;
      axios.defaults.headers.common = {'Authorization': `bearer ${vm.token}`}
      axios.get('jobs/find-skroutz-links')
      vm.$vs.notify({
        color: 'success',
        title: 'Ξεκίνησε η διαδικασία',
        position: 'top-right',
        text: 'Η διαδικασία έχει ξεκινήσει και θα λάβετε ενημέρωση μέσω email μόλις ολοκληρωθεί.'
      });
    },
    deleteAllProductAction() {
      let vm = this;
      vm.$vs.loading();
      axios.defaults.baseURL = vm.apiEndpoint;
      axios.defaults.headers.common = {'Authorization': `bearer ${vm.token}`}
      axios.delete('products/delete-all')
          .then((response) => {
            vm.$vs.notify({
              color: 'success',
              title: 'Επιτυχία',
              position: 'top-right',
              text: 'Τα προϊόντα διαγράφηκαν με επιτυχία.'
            });
            vm.$vs.loading.close();
          })
          .catch((error) => {
            vm.$vs.notify({
              color: 'danger',
              title: 'Αποτυχία',
              position: 'top-right',
              text: 'Τα προϊόντα δεν διαγράφηκαν με επιτυχία.'
            });
            vm.$vs.loading.close();
          })
    },
    syncLinks() {
      let vm = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Επιβεβαίωση`,
        text: 'Θα μεταφερθείτε σε περιβάλλον εισαγωγή νέων συνδέσμων για το skroutz από excel. Είστε σίγουρος;',
        acceptText: 'Άνοιγμα',
        cancelText: 'Ακύρωση',
        accept: this.syncLinksAction
      })
    },
    syncLinksAction() {
      window.location.href = "/settings/importlinks";
    },
    saveSettings() {
      {
        let vm = this;

        // VALIDATION SECTION
        const formData = new FormData();
        vm.$vs.loading();

        formData.append('url', vm.item.url);
        axios.post("xmlOptions/update", formData)
            .then((response) => {
              vm.$vs.loading.close();
              vm.initiated = false;
              vm.$vs.notify({
                color: 'success',
                title: 'Οι αλλαγές αποθηκεύτικαν με επιτυχία',
                position: 'top-right',
                text: response.data.message //'The selected source configuration was successfully saved and new products have been parsed.'
              })
            })
            .catch((error) => {
              vm.$vs.loading.close();
              vm.$vs.notify({
                color: 'warning',
                title: 'Οι αλλαγές δεν αποθηκεύτικαν με επιτυχία',
                position: 'top-right',
                text: 'Παρουσιάστηκε κάποιο σφάλμα και δεν ήταν δυνατή η ανάλυση της πηγής. Ελέγξτε ότι όλα τα πεδία έχουν ρυθμιστεί σωστά με επικεφαλίδες.'
              })
            })
      }
    },
    closePopUp() {
      this.displayPopUp = false
    },
    removeClosePopUp() {
      this.removeDisplayPopUp = false
    },
    cancelUpload() {
      this.item.file = null
    },
    removeXls() {
      let file = this.item.file
      if (file) {
        this.removeDisplayPopUp = true
      } else {
        this.$vs.notify({
          color: 'danger',
          title: 'Δεν υπάρχει αρχείο excel.',
          position: 'top-right',
          text: 'Δεν έχετε επιλέξει αρχείο excel για ανέβασμα.',
        })
      }
    },
    uploadXls() {
      let file = this.item.file
      if (file) {
        this.displayPopUp = true
      } else {
        this.$vs.notify({
          color: 'danger',
          title: 'Δεν υπάρχει αρχείο excel.',
          position: 'top-right',
          text: 'Δεν έχετε επιλέξει αρχείο excel για ανέβασμα.',
        })
      }
    },
    doNotDeleteUpdate() {
      this.uploadMe(this.item.file, 'update')
    },
    deleteAndCreate() {
      this.uploadMe(this.item.file, 'delete')
    },
    removeAllXLSProducts(file, action) {
      this.removeDisplayPopUp = false
      const formData = new FormData()
      formData.append('file', file)
      formData.append('action', action)
      this.$vs.loading()
      axios.defaults.baseURL = this.apiEndpoint
      axios.defaults.headers.common = {
        Authorization: `bearer ${this.token}`,
      }
      axios.post('xmlOptions/remove-excel', formData).then((response) => {
        if (response.data.error === false) {
          this.$vs.loading.close()
          this.$vs.notify({
            color: 'success',
            title: 'Οι αλλαγές ολοκληρώθηκαν με επιτυχία',
            position: 'top-right',
            text: response.data.message, //'The selected source configuration was successfully saved and new products have been parsed.'
          })
          this.item.file = null
          this.$router.replace({ name: 'products-list' })
        } else {
          this.$vs.loading.close()
          this.$vs.notify({
            color: 'warning',
            title: 'Οι αλλαγές δεν ολοκληρώθηκαν με επιτυχία',
            position: 'top-right',
            text: response.data.message,
          })
        }
      })
    },
    uploadMe(file, action) {
      this.displayPopUp = false
      const formData = new FormData()
      formData.append('file', file)
      formData.append('action', action)
      this.$vs.loading()
      axios.defaults.baseURL = this.apiEndpoint
      axios.defaults.headers.common = {
        Authorization: `bearer ${this.token}`,
      }
      axios.post('xmlOptions/import-excel', formData).then((response) => {
        if (response.data.error === false) {
          this.$vs.loading.close()
          this.$vs.notify({
            color: 'success',
            title: 'Οι αλλαγές αποθηκεύτικαν με επιτυχία',
            position: 'top-right',
            text: response.data.message, //'The selected source configuration was successfully saved and new products have been parsed.'
          })
          this.item.file = null
          this.$router.replace({ name: 'products-list' })
        } else {
          this.$vs.loading.close()
          this.$vs.notify({
            color: 'warning',
            title: 'Οι αλλαγές δεν αποθηκεύτικαν με επιτυχία',
            position: 'top-right',
            text: response.data.message,
          })
        }
      })
    },
    getSettings() {
      let vm = this;
      axios.defaults.baseURL = vm.apiEndpoint;
      axios.defaults.headers.common = {'Authorization': `bearer ${vm.token}`}
      axios.get('xmlOptions/list')
          .then((response) => {
            vm.item = response.data;
            vm.$vs.loading.close();
          })
          .catch((error) => {
            vm.$vs.loading.close();
          })
    },
  },
  mounted() {
    let vm = this;
    vm.$vs.loading();
    vm.getSettings()
    vm.$vs.loading.close();
  }
}
</script>
